import React, { useEffect, useState } from "react";
import { useAuth } from "../../../lib/auth";
import storage from "../../../utils/storage";

const CardProductCard = ({
  product,
  handleTotalAmount,
  onQuantityChange,
}: any) => {
  const { user, incrementOrderCount } = useAuth();
  const [quantity, setQuantity] = useState(0);

  useEffect(() => {
    const storageData = storage.getCard();
    if (storageData && Array.isArray(storageData)) {
      const storedProduct = storageData.find(
        (item: any) => item.productId === product.id
      );
      setQuantity(storedProduct ? storedProduct.quantity : 0);
    } else {
      setQuantity(0);
    }
  }, [product.id]);

  const handleIncrement = (e: any) => {
    if (user) {
      e.stopPropagation();
      setQuantity((prev) => {
        const newQuantity = prev + 1;
        onQuantityChange(product.id, newQuantity);
        storage.setCard(product.id, newQuantity);
        incrementOrderCount(true);
        handleTotalAmount(); // Ensure total is recalculated
        return newQuantity;
      });
    }
  };

  const handleDecrement = (e: any) => {
    if (user) {
      e.stopPropagation();
      setQuantity((prev) => {
        const newQuantity = Math.max(0, prev - 1);
        onQuantityChange(product.id, newQuantity);
        storage.setCard(product.id, newQuantity);
        incrementOrderCount(false);
        handleTotalAmount(); // Ensure total is recalculated
        return newQuantity;
      });
    }
  };

  return (
    <div className="relative w-full p-2">
      {/* Shadow layer with slope */}
      <div
        className="absolute -inset-1 "
        style={{
          clipPath: "polygon(0 15%, 85% 0, 100% 0, 100% 100%, 85% 100%, 0 85%)",
          borderTopRightRadius: "8px",
          borderBottomRightRadius: "8px",
          borderTopLeftRadius: "40px",
          borderBottomLeftRadius: "40px",
        }}
      />

      {/* Main container with slope */}
      <div
        className="relative bg-white flex justify-between items-center p-4 hover:shadow-lg transition-shadow"
        style={{
          clipPath: "polygon(0 15%, 85% 0, 100% 0, 100% 100%, 85% 100%, 0 85%)",
          borderTopRightRadius: "8px",
          borderBottomRightRadius: "8px",
          borderTopLeftRadius: "40px",
          borderBottomLeftRadius: "40px",
        }}
      >
        <div className="flex flex-col items-start text-left">
          <p className="font-bold text-lg mt-1 flex">
            <div className="mr-1">الف</div> <div>{product.price}</div>
          </p>
        </div>

        <div
          className="flex items-center justify-center space-x-2 rtl:space-x-reverse"
          style={{ marginRight: "-60px" }}
        >
          {quantity === 0 ? (
            <button
              onClick={handleIncrement}
              className="bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-lg font-semibold transition-colors text-sm"
            >
              إضافة إلى السلة
            </button>
          ) : (
            <div className="flex items-center space-x-2">
              <button
                onClick={handleDecrement}
                className="text-red-600 w-8 h-8 rounded-lg flex items-center justify-center text-xl font-bold"
              >
                -
              </button>
              <span className="text-lg font-semibold w-8 text-center">
                {quantity}
              </span>
              <button
                onClick={handleIncrement}
                className=" text-red-600 w-8 h-8 rounded-lg flex items-center justify-center text-xl font-bold"
              >
                +
              </button>
            </div>
          )}
        </div>
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-semibold text-gray-900 pr-4">
            {product.name_ar}
          </h3>
          <div className="relative h-16 w-16 bg-gray-50 rounded-lg overflow-hidden">
            <img
              src={product.images?.[0]?.image_path || "لا توجد صورة"}
              alt={product.name_ar}
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardProductCard;
